import React, { useState } from "react";
import LookupHeader from "./components/LookupHeader";
import "./components/TxnLookup.css";

function index() {
  const [progress, setProgress] = useState(0);
  const [showProgress, setShowProgress] = useState(false);

  return (
    <div className="main-comp-1">
      <h2 className="area-top-management">Lookup</h2>
      <LookupHeader
        setProgress={setProgress}
        setShowProgress={setShowProgress}
      />
    </div>
  );
}

export default index;